export const properties = [
    {
        id: 1,
        titulo: "Casa Moderna en Santa Ana",
        tipo: "CASA",
        operacion: "VENTA",
        ubicacion: {
            calle: "Avenida Independencia Sur",
            numero: "1234",
            ciudad: "Santa Ana",
            zona: "Santa Ana Centro",
            departamento: "Santa Ana",
            latitud: 13.9942,
            longitud: -89.5445,
            codigoPostal: "510101"
        },
        dimensiones: {
            metrosCuadrados: 200,
            habitaciones: 3,
            banios: 2,
            cocina: true,
            areaLavandera: true,
            sala: true,
            comedor: true
        },
        construccion: {
            anio: 2015,
            arquitecto: "Arq. Carlos López",
            constructor: "Constructora Salvadoreña S.A.",
            tipoConstruccion: "Concreto y acero",
            estado: "Excelente",
            tieneSeguro: true,
            certificadoSeguridadEstructural: true,
            planosCAD: "plano_casa_1.pdf"
        },
        servicios: {
            agua: true,
            electricidad: true,
            internet: true,
            aireAcondicionado: true,
            climatizacion: false,
            piscina: false,
            areaVerdePrivada: true,
            seguridad24h: true,
            estacionamiento: 2
        },
        legal: {
            tieneEscritura: true,
            escrituraInscrita: true,
            tieneLaGravamen: false,
            impuestosAlDia: true,
            historialCambios: "Dueño anterior: Juan Pérez (2015-2026)",
            documentosRequeridos: ["Cédula", "Comprobante Ingresos", "Historial Crediticio"]
        },
        precio: {
            monto: 250000,
            moneda: "USD",
            precioMtrCuadrado: 1250,
            historialPrecios: [
                { fecha: "2026-01", monto: 270000 },
                { fecha: "2026-02", monto: 260000 },
                { fecha: "2026-03", monto: 250000 }
            ],
            impuestosAnuales: 1200,
            hoa: 150,
            estimadoCuotaHipotecaria: 1850,
            esInversion: false
        },
        avaluo: {
            valorCatastral: 245000,
            avaluoOficial: 248000,
            diferenciaPrecio: 2000,
            porcentajeDiferencia: 0.8,
            riesgoZona: "BAJO",
            potencialValorizacion: 3.5
        },
        amenidades: {
            escuelas: ["Colegio San José (500m)", "Escuela Pública (1.2km)"],
            hospitales: ["Hospital Rosario (1.5km)", "Clínica Privada (0.8km)"],
            centrosComerciales: ["Mall Santa Ana (2km)"],
            transportePublico: ["Ruta 42 (300m)", "Ruta 101 (400m)"],
            restaurantes: 12,
            bancosATM: 5,
            parques: ["Parque Bolívar (1km)"],
            seguridad: "Zona segura, vigilancia privada disponible"
        },
        multimedia: {
            fotos: [
                { url: "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", titulo: "Fachada principal", orden: 1 },
                { url: "https://images.unsplash.com/photo-1600596542815-22b8c153bd30?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", titulo: "Sala principal", orden: 2 },
                { url: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", titulo: "Cocina", orden: 3 },
                { url: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", titulo: "Habitación Master", orden: 4 }
            ],
            video360: "https://viewer.matterport.com/show/?m=example",
            videoPresentation: "https://youtube.com/example",
            plano: "plano.pdf",
            doctosConstruccion: ["escritura.pdf", "licencia_construccion.pdf"]
        },
        agente: {
            nombre: "Carlos Medina",
            especialidad: "Vivienda residencial de lujo",
            telefono: "+503 7654-3210",
            email: "carlos@futura.sv",
            foto: "https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
            experiencia_anos: 8,
            propiedadesVendidas: 45,
            certificacion: "AREIM (Asociación Real Estate)",
            disponibilidadTours: {
                lunes: "09:00-17:00",
                martes: "09:00-17:00"
            }
        },
        estado: "DISPONIBLE",
        fechaPublicacion: "2026-12-01",
        ultimaActualizacion: "2026-12-09",
        esTrending: true,
        esNueva: true,
        vistas: 245
    },
    {
        id: 2,
        titulo: "Apartamento con Vista al Volcán",
        tipo: "APARTAMENTO",
        operacion: "ALQUILER",
        ubicacion: {
            calle: "Paseo General Escalón",
            numero: "500",
            ciudad: "San Salvador",
            zona: "Escalón",
            departamento: "San Salvador",
            latitud: 13.708,
            longitud: -89.243,
            codigoPostal: "110111"
        },
        dimensiones: {
            metrosCuadrados: 110,
            habitaciones: 2,
            banios: 2,
            cocina: true,
            areaLavandera: true,
            sala: true,
            comedor: true
        },
        construccion: {
            anio: 2020,
            arquitecto: "Arq. María Ruiz",
            constructor: "Desarrollos Urbanos",
            tipoConstruccion: "Concreto",
            estado: "Excelente",
            tieneSeguro: true,
            certificadoSeguridadEstructural: true,
            planosCAD: ""
        },
        servicios: {
            agua: true,
            electricidad: true,
            internet: true,
            aireAcondicionado: true,
            climatizacion: true,
            piscina: true,
            areaVerdePrivada: false,
            seguridad24h: true,
            estacionamiento: 1
        },
        legal: {
            tieneEscritura: true,
            escrituraInscrita: true,
            tieneLaGravamen: false,
            impuestosAlDia: true,
            historialCambios: "",
            documentosRequeridos: ["DUI", "NIT", "Constancia Salarial"]
        },
        precio: {
            monto: 1200,
            moneda: "USD",
            precioMtrCuadrado: 0, // Alquiler
            historialPrecios: [],
            impuestosAnuales: 0,
            hoa: 100,
            estimadoCuotaHipotecaria: 0,
            esInversion: false
        },
        avaluo: {
            valorCatastral: 0,
            avaluoOficial: 0,
            diferenciaPrecio: 0,
            porcentajeDiferencia: 0,
            riesgoZona: "BAJO",
            potencialValorizacion: 0
        },
        amenidades: {
            escuelas: ["Escuela Americana (1km)"],
            hospitales: ["Hospital de Diagnóstico (500m)"],
            centrosComerciales: ["Galerías (800m)"],
            transportePublico: ["Ruta 52 (100m)"],
            restaurantes: 20,
            bancosATM: 10,
            parques: ["Plaza Beethoven (600m)"],
            seguridad: "Zona exclusiva con vigilancia privada"
        },
        multimedia: {
            fotos: [
                { url: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", titulo: "Vista Principal", orden: 1 },
                { url: "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", titulo: "Interior", orden: 2 }
            ],
            video360: "",
            videoPresentation: "",
            plano: "",
            doctosConstruccion: []
        },
        agente: {
            nombre: "Ana Martínez",
            especialidad: "Alquileres Ejecutivos",
            telefono: "+503 2222-5555",
            email: "ana@futura.sv",
            foto: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
            experiencia_anos: 5,
            propiedadesVendidas: 120,
            certificacion: "AREIM",
            disponibilidadTours: {
                lunes: "08:00-18:00",
                viernes: "08:00-18:00"
            }
        },
        estado: "DISPONIBLE",
        fechaPublicacion: "2026-12-05",
        ultimaActualizacion: "2026-12-09",
        esTrending: true,
        esNueva: true,
        vistas: 150
    },
    {
        id: 3,
        titulo: "Terreno en Coatepeque",
        tipo: "TERRENO",
        operacion: "VENTA",
        ubicacion: {
            calle: "Carretera al Lago",
            numero: "S/N",
            ciudad: "El Congo",
            zona: "Lago de Coatepeque",
            departamento: "Santa Ana",
            latitud: 13.870,
            longitud: -89.500,
            codigoPostal: "510102"
        },
        dimensiones: {
            metrosCuadrados: 1500,
            habitaciones: 0,
            banios: 0,
            cocina: false,
            areaLavandera: false,
            sala: false,
            comedor: false
        },
        construccion: {
            anio: 0,
            arquitecto: "",
            constructor: "",
            tipoConstruccion: "",
            estado: "",
            tieneSeguro: false,
            certificadoSeguridadEstructural: false,
            planosCAD: ""
        },
        servicios: {
            agua: true,
            electricidad: true,
            internet: false,
            aireAcondicionado: false,
            climatizacion: false,
            piscina: false,
            areaVerdePrivada: true,
            seguridad24h: false,
            estacionamiento: 0
        },
        legal: {
            tieneEscritura: true,
            escrituraInscrita: true,
            tieneLaGravamen: false,
            impuestosAlDia: true,
            historialCambios: "",
            documentosRequeridos: ["DUI", "NIT"]
        },
        precio: {
            monto: 85000,
            moneda: "USD",
            precioMtrCuadrado: 56.66,
            historialPrecios: [],
            impuestosAnuales: 150,
            hoa: 0,
            estimadoCuotaHipotecaria: 650,
            esInversion: true
        },
        avaluo: {
            valorCatastral: 80000,
            avaluoOficial: 82000,
            diferenciaPrecio: 3000,
            porcentajeDiferencia: 3.5,
            riesgoZona: "BAJO",
            potencialValorizacion: 8.0
        },
        amenidades: {
            escuelas: [],
            hospitales: [],
            centrosComerciales: [],
            transportePublico: ["Buses interdepartamentales (1km)"],
            restaurantes: 5,
            bancosATM: 0,
            parques: ["Lago de Coatepeque (0m)"],
            seguridad: "Zona turística tranquila"
        },
        multimedia: {
            fotos: [
                { url: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", titulo: "Vista al Lago", orden: 1 }
            ],
            video360: "",
            videoPresentation: "",
            plano: "",
            doctosConstruccion: []
        },
        agente: {
            nombre: "Carlos Medina",
            especialidad: "Terrenos y Fincas",
            telefono: "+503 7654-3210",
            email: "carlos@futura.sv",
            foto: "https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
            experiencia_anos: 8,
            propiedadesVendidas: 45,
            certificacion: "AREIM",
            disponibilidadTours: {
                lunes: "09:00-17:00"
            }
        },
        estado: "DISPONIBLE",
        fechaPublicacion: "2026-11-15",
        ultimaActualizacion: "2026-12-01",
        esTrending: true,
        esNueva: false,
        vistas: 300
    }
];
